// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalES = {
  question_option_label: 'Opción {{option}} de la pregunta {{question}}',
  surveys: 'Cuestionarios',
  survey: 'Cuestionario',
  listen_to_your_customers_and_assign_tags_after_submission:
    'Escucha a tus clientes y asigna etiquetas tras el envío.',
  select_a_venue_to_manage_surveys:
    'Selecciona un local para gestionar los cuestionarios.',
  create_survey: 'Crear cuestionario',
  edit_survey: 'Editar cuestionario',
  search_surveys_by_name: 'Buscar cuestionarios por nombre',
  search_for_a_survey_by_name: 'Busca un cuestionario por nombre…',
  no_surveys_found: 'No se encontraron cuestionarios',
  create_your_first_survey_to_collect_feedback_and_ratings:
    'Crea tu primer cuestionario para recoger opiniones y valoraciones.',
  published: 'Publicado',
  paused_draft: 'En pausa / borrador',
  responses: 'Respuestas',
  rating: 'Valoración',
  none_yet: 'Todavía ninguna',
  customer_link: 'Enlace del cliente',
  surveys_2: 'cuestionarios',
  questions: 'preguntas ·',
  tags: 'etiquetas',
  responses_2: 'respuestas',
  survey_saved: 'Cuestionario guardado',
  save_survey: 'Guardar cuestionario',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    'Escribe las preguntas. Al final siempre se incluye una valoración de cinco estrellas.',
  survey_name: 'Nombre del cuestionario *',
  e_g_how_was_your_dinner: 'Ej. ¿Qué te pareció la cena?',
  introduction_for_the_customer: 'Introducción para el cliente',
  tags_to_add_after_submission: 'Etiquetas que añadir tras el envío',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    'Se añaden a las etiquetas del cliente sin eliminar las existentes.',
  loading_tags: 'Cargando etiquetas…',
  select_venue_tags: 'Selecciona etiquetas del local',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    'El servicio conectado aún no admite etiquetas de preguntas y respuestas. Puedes configurarlas aquí, pero para guardarlas es necesario actualizar el servicio.',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    'Las etiquetas de preguntas y respuestas requieren actualizar el servicio conectado. El cuestionario no se ha guardado.',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    'Introduce el nombre, el texto de las preguntas y al menos dos opciones diferentes para las preguntas de selección.',
  question: 'Pregunta',
  question_text: 'Texto de la pregunta *',
  answer_type: 'Tipo de respuesta',
  text_answer: 'Respuesta abierta',
  single_choice_one_answer: 'Selección única — una respuesta',
  multiple_choice_several_answers: 'Selección múltiple — varias respuestas',
  question_tags: 'Etiquetas de la pregunta',
  added_when_the_customer_answers_this_question:
    'Se añaden cuando el cliente responde a esta pregunta.',
  no_tags_for_this_question: 'Sin etiquetas para esta pregunta',
  answer_options_2_to_20: 'Opciones de respuesta (de 2 a 20)',
  tags_when_the_customer_selects_this_answer:
    'Etiquetas si el cliente elige esta respuesta',
  select_tags_for_this_answer: 'Selecciona etiquetas para esta respuesta',
  add_option: 'Añadir opción',
  remove_option: 'Eliminar opción',
  required_answer: 'Respuesta obligatoria',
  add_question: 'Añadir pregunta',
  move_question_up: 'Subir pregunta',
  move_question_down: 'Bajar pregunta',
  remove_question: 'Eliminar pregunta',
  final_rating_from_1_to_5_stars: 'Valoración final de 1 a 5 estrellas',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    'El cliente elige las estrellas antes de enviar el cuestionario.',
  publish_survey: 'Publicar el cuestionario',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    'Si se desactiva, los enlaces no aceptan respuestas. Las respuestas existentes se conservan.',
  survey_preview: 'Vista previa del cuestionario',
  create_a_customer_link: 'Crear un enlace para un cliente',
  search_customers_by_name_email_or_code:
    'Busca clientes por nombre, correo o código',
  type_at_least_2_characters: 'Escribe al menos 2 caracteres…',
  searching: 'Buscando…',
  no_customers_found: 'No se encontraron clientes.',
  generate_customer_link: 'Generar enlace del cliente',
  this_link_associates_the_response_with_the_selected_customer:
    'Este enlace asocia la respuesta al cliente seleccionado.',
  survey_link: 'Enlace del cuestionario',
  link_copied: 'Enlace copiado',
  copy_the_link_manually_from_the_field_above:
    'Copia manualmente el enlace del campo anterior.',
  loading_responses: 'Cargando respuestas…',
  you_have_not_received_any_responses_yet: 'Aún no has recibido respuestas.',
  tags_added: 'Etiquetas añadidas:',
  the_request_could_not_be_completed: 'No se pudo completar la solicitud.',
  your_opinion_matters: 'Tu opinión importa',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    'El enlace está incompleto. Pide uno nuevo al local.',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    'Este cuestionario no está disponible. Pide un nuevo enlace al local.',
  we_could_not_load_the_survey_please_try_again:
    'No pudimos cargar el cuestionario. Inténtalo de nuevo.',
  loading_failed: 'Error de carga.',
  the_survey_has_been_updated_please_review_the_questions:
    'El cuestionario se ha actualizado. Revisa las preguntas.',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    'Revisa las respuestas y elige de 1 a 5 estrellas.',
  submission_failed_please_try_again_shortly:
    'Error al enviar. Inténtalo de nuevo en breve.',
  submission_failed: 'Error al enviar.',
  your_voice_helps_us_grow: 'Tu voz nos ayuda a crecer',
  a_moment_to_listen: 'UN MOMENTO PARA ESCUCHARTE',
  your_feedback_makes_a_difference: 'Tu opinión marca la diferencia.',
  preparing_your_survey: 'Preparando tu cuestionario…',
  responses_sent: 'RESPUESTAS ENVIADAS',
  thank_you_for_your_feedback: '¡Gracias por tu opinión!',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    'Tus respuestas se han guardado. Gracias por dedicar un momento a ayudarnos a mejorar.',
  tell_us_about_your_experience: 'Cuéntanos tu experiencia',
  answer_the_questions_and_leave_your_final_rating:
    'Responde a las preguntas y deja tu valoración final.',
  your_answers_are_linked_to_your_customer_profile:
    'Las respuestas se asocian a tu perfil de cliente.',
  powered_by: 'Creado con',
  optional: ' (opcional)',
  write_your_answer_here: 'Escribe aquí tu respuesta…',
  choose_one_answer: 'Elige una sola respuesta.',
  you_can_choose_several_answers: 'Puedes elegir varias respuestas.',
  how_would_you_rate_your_experience: '¿Cómo valoras tu experiencia? *',
  choose_from_1_to_5_stars: 'Elige de 1 a 5 estrellas.',
  no_rating_selected: 'Ninguna valoración seleccionada',
  submit_your_feedback: 'Enviar tu opinión',
  text_answers_can_contain_up_to_5_000_characters:
    'Las respuestas abiertas admiten hasta 5000 caracteres.',
  choose_a_valid_answer: 'Elige una respuesta válida.',
  choose_only_the_available_options: 'Elige solo las opciones disponibles.',
  choose_a_rating_from_1_to_5_stars: 'Elige una valoración de 1 a 5 estrellas.',
  complete_the_question_value: 'Completa la pregunta: {{question}}',
  value_out_of_5_stars: '{{count}} de 5 estrellas',
  value_stars: '{{count}} estrellas',
  value_questions_value_tags: '{{count}} preguntas · {{tags}} etiquetas',
  value_responses: '{{count}} respuestas',
  value_surveys: '{{count}} cuestionarios',
  value_questions_rating: '{{count}} preguntas + valoración',
  responses_value: 'Respuestas · {{name}}',
};
